import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBookmark"><Path d="M19.5 21.5V2.5H4.5V21.5L12 17.5L19.5 21.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBookmark;
